import * as yup from 'yup'

export const addInsuranceValidation: yup.SchemaOf<any> = yup
  .object({
    Agent: yup.string().required().nullable().label('Agent'),
    IsCPI: yup.boolean().required().label('Is CPI'),
  })
  .required()
